import { render, staticRenderFns } from "./customForm.vue?vue&type=template&id=632ca4ee"
import script from "./customForm.vue?vue&type=script&lang=js"
export * from "./customForm.vue?vue&type=script&lang=js"
import style0 from "./customForm.vue?vue&type=style&index=0&id=632ca4ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports